import React, { useRef, useState, useContext } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import FreeTextFormat from "../shared/FreeTextFormat"
import CommentSection from "../comments/CommentSection"
import { PostListItemExpandedStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import { transformCloudUrl } from "../../util/strings"
import { Player, ControlBar } from "video-react"
import "/node_modules/video-react/dist/video-react.css"
import PremiereHeader from "./PremiereHeader"
import clsx from "clsx"
import styles from "./styles.module.css"
import HeadlinePostForm from "../HeadlinePostForm"
import { UserContext } from "../HomeApp"
import EditManageHeader from "../EditManageHeader"

export const VideoListItemExpanded = ({
  video,
  updateStatus,
  adminMode = false,
  isPostPage = false,
}) => {
  const metaClass = isPostPage
    ? "col-span-12 pt-2"
    : PostListItemExpandedStyles.metaDiv
  const commentsClass = isPostPage
    ? "col-span-12 pt-4"
    : PostListItemExpandedStyles.commentsDiv
  const [postStatus, setPostStatus] = useState(video.status)
  const [currentVideo, setCurrentVideo] = useState(video)
  const [showEditForm, setShowEditForm] = useState(false)
  const { user } = useContext(UserContext)
  const isOwner = user && user.band && user.band.id === video.band_id
  const fullText = video.original_text
    ? `${video.original_text}\n\n${video.description}`
    : `New Headline from ${video.band_name}`

  return showEditForm ? (
    <HeadlinePostForm
      bandId={user.band_id}
      setShowForm={setShowEditForm}
      post={video}
      setNewPost={setCurrentVideo}
    />
  ) : (
    <div className="grid grid-cols-12">
      <PremiereHeader post={video} size="large" />
      <div className={PostListItemExpandedStyles.contentDiv}>
        {!video.embed_url ? (
          <>
            <Player autoPlay src={transformCloudUrl(video.external_url)}>
              <ControlBar autoHide={true} />
            </Player>
          </>
        ) : (
          <iframe
            src={video.embed_url}
            width="100%"
            height="auto"
            title={video.title}
            allow="fullscreen"
            style={{ aspectRatio: "16/9", backgroundColor: "black" }}
          />
        )}
      </div>
      <div className={metaClass}>
        <EditManageHeader
          isOwner={isOwner}
          post={video}
          setShowEditForm={setShowEditForm}
        />
        <div className="flex items-start justify-between">
          <div className="flex-grow">
            <h2
              className={clsx(
                PostListItemExpandedStyles.header,
                video.title.length > 100
                  ? PostListItemExpandedStyles.headerLong
                  : PostListItemExpandedStyles.headerShort,
                video.is_bn_premiere && styles.premiereTitle,
              )}
            >
              <FreeTextFormat
                text={
                  video.title
                    ? video.title_cleaned || video.title
                    : `New Headline from ${video.band_name}`
                }
                expandable={false}
                expanded={false}
                linkify={false}
              />
            </h2>
          </div>
          <ShareUrlButton
            nadaUrl={video.nada_url}
            renderMode="button"
            className="ml-0"
          />
        </div>
        <Link
          className={PostListItemExpandedStyles.bandName}
          to={video.local_path}
        >
          {video.band_name}
        </Link>
        <h3 className={PostListItemExpandedStyles.postDate}>
          Released:&nbsp;
          {SmartDateFormat({ dateStr: video.published_at, includeTime: false })}
        </h3>
        {video.view_on && (
          <div className={PostListItemExpandedStyles.externalLink}>
            <a href={video.external_url} target="_blank" rel="noreferrer">
              view on&nbsp;
              {video.view_on}
            </a>
          </div>
        )}

        <div className="mt-4">
          <ReactionBlock
            contentType="Post"
            contentId={video.id}
            postId={video.id}
          />
        </div>

        <div className="text-sm text-gray-800 mt-4">
          <FreeTextFormat
            text={fullText}
            expandable={false}
            expanded={true}
            linkify={false}
            stripLinks={true}
          />
        </div>
      </div>
      <div className={commentsClass}>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}

        <RelatedPosts postId={video.id} className="mb-4" />

        <CommentSection
          postId={video.id}
          headerText="The Peanut Gallery Says:"
          className="mb-4"
        />
      </div>
    </div>
  )
}
